import { toast } from '@/components/toast';
import { useAnalytics } from '@/services/analytics';
import { applyBackground } from '@/services/api';
import { VideoType } from '@d-id/types';
import { AxiosError } from 'axios';
import { useMutation } from 'react-query';

export const useApplyBackground = (
    onSuccessCallback?: ({
        resultUrl,
        backgroundUrl,
        videoType,
    }: {
        resultUrl: string;
        backgroundUrl: string;
        videoType?: VideoType;
    }) => Promise<void>,
    videoType?: VideoType
) => {
    const mixpanel = useAnalytics();

    return useMutation(applyBackground, {
        onSuccess: async ({ result_url }, { background_url }) => {
            mixpanel?.track('apply-background', { event: 'success', result_url, background_url });
            if (result_url && onSuccessCallback) {
                await onSuccessCallback({ resultUrl: result_url, backgroundUrl: background_url, videoType });
            }
        },
        onError: (error: AxiosError<{ kind: string; description?: string }>) => {
            const kind = error?.response?.data?.kind;
            mixpanel?.track('delete-image', { kind, event: 'error' });
            toast.error({ title: 'Failed to apply background to image, please try again', toastId: `apply-background-error` });
        },
    });
};
